import React, { useState, useEffect } from 'react';
import Post from '../../../../utils/Post';
import VainillaDialog from '../../../sharecomponents/vanilladialog';
import { activeDialog } from '../../../../utils/Common';
import ContenedorEjecucionMovil from './components/ContenedorEjecucionMovil';
import ListaEjecucionPC from './components/ListaEjecucionPC';
import { generarExcel } from '../../../sharecomponents/ExcelUtilities';
import Verifiers from '../../../../utils/Verifiers.jsx';

const EjecucionInventarioCampo = () => {
    const [loader, setloader] = useState(false);
    const ldr = (<div className='vw-100 vh-100 top-left-front bg-white3 blur-s'><div className='loader' /></div>);
    const [dialog, setdialog] = useState({ show: false });
    const [filtros, setfiltros] = useState({ semanas: [], variedades: [], colores: [], flores: [], ranchos: [], valvulas: [] });
    const [paginador, setpaginador] = useState({ semana: '', variedad: '', color: '', flor: '', rancho: '', valvula: '' });
    const [totales, settotales] = useState({
        "ejecutado": 0,
        "planeado": 0,
        "lunes_plan": 0,
        "lunes_ejecutado": 0,
        "martes_plan": 0,
        "martes_ejecutado": 0,
        "miercoles_plan": 0,
        "miercoles_ejecutado": 0,
        "jueves_plan": 0,
        "jueves_ejecutado": 0,
        "viernes_plan": 0,
        "viernes_ejecutado": 0,
        "sabado_plan": 0,
        "sabado_ejecutado": 0,
        "diferencia": 0,
        "porcentaje_ejecutado": 0
    });
    const [data, setdata] = useState([]);
    const campoFiltroNombre = { 'semanas': 'semana', 'flores': 'flor', 'variedades': 'variedad', 'colores': 'color', 'ranchos': 'rancho', 'valvulas': 'valvula' };
    const dias = ['lunes', 'martes', 'miercoles', 'jueves', 'viernes', 'sabado'];
    const [modo, setmodo] = useState("completo");
    var counter = 0;
    useEffect(() => {
        getData(paginador, true);
    }, []);

    const keyGen = () => { counter++; return counter; }

    /**
     * Obtiene los datos de ejecución del plan de campo y los filtros asociados a ese, el proceso se realiza correctamente se llenan las variables de estado
     * @param {object} pg paginador con opciones de filtrado, si no se manda se usa el actual   
     * @param {boolean} loader True si se desea activar la animación de carga, falso si no
     * @returns vold
     */
    const getData = async (pg = { ...paginador }, loader = false) => {
        let resp = await Post('/campo/v2/inventarios/ejecucion/get', pg, 'POST', loader ? setloader : false);
        if (!resp.estatus) {
            activeDialog(setdialog, resp.msj, 'error', 'Error');
            return false;
        }
        setpaginador(pg);
        setdata(resp.data);
        setfiltros(resp.filtros);
        settotales(resp.totales);
        Verifiers.scrollAnimacion('lista_normal0', 250);
    }

    /**
     * ajusta el paginador y solicita una nueva consulta usando el nuevo paginador
     * @param {object} e evento del input
     */
    const aplicarFiltro = (e) => {
        let { name, value } = e.target;
        let pg = { ...paginador, [name]: value };
        if (name === 'semana') {
            pg = { semana: value, variedad: '', color: '', flor: '', rancho: '', valvula: '' };
        }
        getData(pg, true);
    }

    /**
     * Llama al servidor para actualizar el avance de un dpia especifico, en caso de error se regresa al valor original, en caso exitoso se actualiza el estado de todas las variables
     * @param {number} dia Numero del dia a reportar, el rango va desde 1 (lunes) a 6 (sabado)
     * @param {number} plantas cntidad de plantas a reportar, si no se reciben numeros se asume 0
     * @param {number} index indice del registro que se va a editar
     * @returns 
     */
    const reportarAvance = async (dia, plantas, index) => {
        if (['', null, undefined, 'e'].includes(plantas)) plantas = 0;
        let registroOriginal = JSON.parse(JSON.stringify(data[index])); //asegurarnos de no ir a modificar el original
        data[index][dia + "_ejecutado"] = plantas;
        console.log(registroOriginal)
        let dataSend = { ...paginador, inventario_campo_id: registroOriginal.id, dia: dia, plantas: plantas, valvula_registro: registroOriginal.valvula, cama_inicio_registro: registroOriginal.cama_inicio, };
        let resp = await Post('/campo/v2/inventarios/ejecucion/add', dataSend, 'POST', false);
        if (!resp.estatus) {
            activeDialog(setdialog, resp.msj, 'error', 'Error');
            data[index][dia + "_ejecutado"] = registroOriginal[dia + "_ejecutado"];
            return false;
        }
        setdata(resp.data);
        setfiltros(resp.filtros);
        settotales(resp.totales);
    }

    /**
     * Alterna entre los 3 modos de vision, completo, normal y movil
     */
    const cambiarModo = () => {
        let modos = ['completo', 'normal', 'movil'];
        let index = modos.indexOf(modo);
        index++;
        if (index >= modos.length) index = 0;
        setmodo(modos[index]);
    }

    /**
     * Da formato a los datos y los descarga en un archivo excel con ellos
     * @returns void
     */
    const formatearYDescargarExcel = () => {
        if (data.length === 0) return;
        let formateado = [];
        data.forEach(element => {
            formateado.push({
                BLOQUE: element.bloque,
                'SEMANA TRASPLANTE': element.semana_trasplante,
                'RANCHO': element.rancho,
                'VALVULA': element.valvula,
                'CAMA INICIO': element.cama_inicio,
                'CAMA FIN': element.cama_fin,
                'PALNTAS PLANIFICADAS': element.plantas_plan,
                'PLANTAS EJECUTADAS': element.total_plantas_ejecutado,
                DIFERENCIA: element.diferencia,
                'LUNES PLAN': element.lunes_plan,
                'LUNES EJECUTADO': element.lunes_ejecutado,
                'MARTES PLAN': element.martes_plan,
                'MARTES EJECUTADO': element.martes_ejecutado,
                'MIERCOLES PLAN': element.miercoles_plan,
                'MIERCOLES EJECUTADO': element.miercoles_ejecutado,
                'JUEVES PLAN': element.jueves_plan,
                'JUEVES EJECUTADO': element.jueves_ejecutado,
                'VIERNES PLAN': element.viernes_plan,
                'VIERNES EJECUTADO': element.viernes_ejecutado,
                'SABADO PLAN': element.sabado_plan,
                'SABADO EJECUTADO': element.sabado_ejecutado,
            });
        });
        generarExcel(formateado, `Ejec_plan_campo_${paginador.semana}`);
    }

    return (
        <div className='vw-100 p-2 overflow bg-white p-2 dosis' style={{ height: "calc( 100vh - 60px)" }}>
            <div className='row justify-content-evenly w-100 m-0 p-0'>
                <div className='w-100 round-left-xxl gradient-small-black text-white text-300 p-1 ps-3 text-l'>
                    <div className='row justify-content-between w-100 m-0 p-0'>
                        <div className='col-auto text-start contenedor p-0'>Ejecucion de plan de campo</div>
                        <div className='bw-150'>
                            <div className='row justify-content-end w-100 m-0 p-0'>
                                <div className={`col-auto p-1 pt-0 pb-0 border border text-white text-bold round-m ${data.length === 0 ? 'opacity-50' : 'pointer scale-05'} bg-success text-s contenedor me-3`}
                                    onClick={formatearYDescargarExcel}>EXCEL</div>
                                <div className='col-auto ps-1 pe-1 pt-0 pb-0 border border text-dark text-bold round-m pointer scale-05 bg-warning text-s contenedor'
                                    onClick={cambiarModo}>{modo.toUpperCase()}</div>
                            </div>
                        </div>
                    </div>

                </div>

                {Object.keys(filtros).map((f, i) =>
                    <div className='form-group bw-150 boorder border-bottom pb-1 round-xxl mt-2' key={keyGen()}>
                        <label className='text-bold text-xs ps-3'>{campoFiltroNombre[f].toUpperCase()}</label>
                        <select className={'form-control form-control-sm shadow border round-xxl ' + (campoFiltroNombre[f] === 'semana' ? 'tborder-2 border-warning' : '')}
                            name={campoFiltroNombre[f]}
                            value={paginador[campoFiltroNombre[f]]}
                            onChange={aplicarFiltro}>
                            <option value='' >{f == 'semanas' ? "Seleccione una" : "Sin filtrar"}</option>
                            {filtros[f].map((filtro, j) =>
                                <option key={keyGen()} value={f === 'semanas' ? filtro : filtro.key}>{f === 'semanas' ? filtro : filtro.value.toUpperCase()}</option>
                            )}
                        </select>
                    </div>
                )}
                {paginador.semana == "" && <div className='w-100 text-center h3 text-300 mt-5'>Para empezar seleccione una semana</div>}
                {modo !== "movil" && data.length > 0 && <ListaEjecucionPC data={data} modo={modo} reportarAvance={reportarAvance} keyGen={keyGen} totales={totales} />}
                {modo === "movil" && data.length > 0 && <>
                    <div className='w-100' />
                    {data.map((d, i) => <React.Fragment key={keyGen()}>  <ContenedorEjecucionMovil data={d} index={i} reportarAvance={reportarAvance} /> </React.Fragment>)}
                </>}
            </div>
            {loader ? ldr : null}
            <VainillaDialog data={dialog} />
        </div >
    )
}

export default EjecucionInventarioCampo;